import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=5b429721&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=5b429721&prod&scoped=true&lang=css&"
import style1 from "./VideoPlayer/video_player.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b429721",
  null
  
)

export default component.exports